import { NgModule } from '@angular/core';
import { SharedModule } from '../../../shared';
import { UsuarioFilterPipe } from './usuario-filter.pipe';
import { UsuarioPerfilPipe } from './usuario-perfil.pipe';

@NgModule({
    imports: [
        SharedModule
    ],
    declarations: [
        UsuarioFilterPipe,
        UsuarioPerfilPipe
    ],
    exports: [
        UsuarioFilterPipe,
        UsuarioPerfilPipe
    ],
    providers: [
        UsuarioFilterPipe,
        UsuarioPerfilPipe
    ]
})
export class UsuarioPipesModule { }
